/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Category_Products_TitleInputs */

const en_directory_taxonomy_index_category_products_title = /** @type {(inputs: Directory_Taxonomy_Index_Category_Products_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published products`)
};

const zh_directory_taxonomy_index_category_products_title = /** @type {(inputs: Directory_Taxonomy_Index_Category_Products_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发布产品`)
};

/**
* | output |
* | --- |
* | "Published products" |
*
* @param {Directory_Taxonomy_Index_Category_Products_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_category_products_title = /** @type {((inputs?: Directory_Taxonomy_Index_Category_Products_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Category_Products_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_category_products_title(inputs)
	return zh_directory_taxonomy_index_category_products_title(inputs)
});
export { directory_taxonomy_index_category_products_title as "directory.taxonomy_index.category.products_title" }